module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "45px"
    }
  }, [_c('mt-textarea', {
    attrs: {
      "label": "有标题",
      "placeholder": "全宽度",
      "rows": "3",
      "maxlength": "100",
      "wrapperpaddingleft": "20px"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mt-cell-group', [_c('mt-textarea', {
    attrs: {
      "placeholder": "全宽度",
      "rows": "3",
      "maxlength": "100"
    }
  }), _vm._v(" "), _c('mt-textarea', {
    attrs: {
      "label": "success",
      "placeholder": "success",
      "rows": "3",
      "maxlength": "50",
      "state": "success"
    }
  }), _vm._v(" "), _c('mt-textarea', {
    attrs: {
      "label": "danger",
      "placeholder": "danger",
      "rows": "3",
      "maxlength": "20",
      "state": "danger"
    }
  }), _vm._v(" "), _c('mt-textarea', {
    attrs: {
      "label": "warning",
      "placeholder": "warning",
      "rows": "3",
      "maxlength": "10",
      "state": "warning"
    }
  }), _vm._v(" "), _c('mt-textarea', {
    attrs: {
      "placeholder": "右侧自定义内容",
      "rows": "3",
      "maxlength": "50"
    }
  }, [_vm._v("自定义")]), _vm._v(" "), _c('mt-textarea', {
    attrs: {
      "placeholder": "同时出现",
      "rows": "3",
      "maxlength": "20",
      "state": "error"
    }
  }, [_c('mt-icon', {
    attrs: {
      "name": "icon-wifi"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22cac266","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/textarea.vue
// module id = 640
// module chunks = 0